import axios from "axios";

const LOCAL_DEV_API_URL = "https://api.dev.yolk.coach";

export const getApiBaseUrl = (): string => {
  const configured = process.env.NEXT_PUBLIC_YOLK_API_URL;
  if (!configured) {
    if (process.env.NODE_ENV === "development") return LOCAL_DEV_API_URL;
    throw new Error("NEXT_PUBLIC_YOLK_API_URL is not set.");
  }
  // Public routes live at the origin; the configured value may carry an
  // /_internal/app suffix meant for the authenticated fetchers.
  return new URL(configured).origin;
};

const API_URL = getApiBaseUrl();

/** Unauthenticated: no NextAuth interceptor or Authorization header, unlike @workspace/api's fetcher. */
export const publicClientFetcher = axios.create({
  baseURL: API_URL,
});

publicClientFetcher.interceptors.request.use((config) => {
  if (!(config.data instanceof FormData)) {
    config.headers.set("Content-Type", "application/json");
  }
  config.headers.set("Accept", "application/json");
  return config;
});
